import React from 'react'
import styles from './StatusBadge.module.scss'

interface Props {
  status: string
}

export default function StatusBadge({ status }: Props) {
  const normalized = status.toLowerCase()
  const variant =
    normalized === 'active'
      ? styles.active
      : normalized === 'invited'
        ? styles.invited
        : styles.inactive
  const label = status.charAt(0).toUpperCase() + status.slice(1).toLowerCase()

  return (
    <span className={`${styles.badge} ${variant}`}>
      <span className={styles.dot} />
      {label}
    </span>
  )
}
